import React from "react";

import { Stack, ThemeProvider } from "@mui/material";
import { Box } from "@mui/system";
import { Outlet } from "react-router-dom";

import { ReactComponent as Logo } from "../../../Assets/Images/logo/Logo.svg";
import { Theme } from "../../../Style/Theme";
import TopNavigationBar from "../../molecules/TopNavigationBar/TopNavigationBar";
export const AuthLayout = () => {
  return (
    <ThemeProvider theme={Theme}>
      <Box
        height={"100vh"}
        width={"100%"}
        display={"flex"}
        alignItems={"center"}
        flexDirection={"column"}
        bgcolor={Theme.palette.background.offWhite}
      >
        <TopNavigationBar
          justifyContent={"center"}
          backgroundColor={Theme.palette.background.pureWhite}
          minHeight={"68px"}
        >
          <Logo type="img" role="img" width={'190px'} height={"64px"}/>
          
        </TopNavigationBar>

        <Stack
          style={{
            width: "auto",
            height: "auto",
            borderRadius: "10px",
            backgroundColor: "white",
            margin: "32px",
            marginTop: "91px",
          }}
        >
          <Outlet />
        </Stack>
      </Box>
    </ThemeProvider>
  );
};
